import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MOCK_TIPS_PREVIEWS, TipPreview } from '../mock-data/mock-sports.data';

@Component({
  selector: 'app-tips-and-previews-details',
  templateUrl: './tips-and-previews-details.component.html',
  styleUrls: ['./tips-and-previews-details.component.scss'],
})
export class TipsAndPreviewsDetailsComponent implements OnInit {
  tip: TipPreview | undefined;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      this.tip = MOCK_TIPS_PREVIEWS.find(t => t.id === id);
    });
  }
}
